/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const InfoBadge16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <g fill={vars.bdlGray} fillRule="evenodd">
            <path fillRule="nonzero" d="M8 1a7 7 0 110 14A7 7 0 018 1zm0 1a6 6 0 100 12A6 6 0 008 2z" />
            <path d="M7 12a.5.5 0 110-1h.5V8H7a.5.5 0 010-1h1.5a.5.5 0 01.488.611A.782.782 0 019 7.75V11h.5a.5.5 0 110 1H7zm1-8a1 1 0 110 2 1 1 0 010-2z" />
        </g>
    </AccessibleSVG>
);

export default InfoBadge16;
